<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="退款退货" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="menu">
      <div @click="$router.push({name:'MemberReturnList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">退货管理</span></flex-line></div>
      <div @click="$router.push({name:'MemberRefundList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">退款管理</span></flex-line></div>
      <div @click="$router.push({name:'MemberVrRefundList'})"><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">虚拟退款</span></flex-line></div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import flexLine from '../../flexLine'
export default {
  components:{
  flexLine,
  },
  data () {
    return {
    }
  },
  created () {

  },

  mounted () {

  },
  methods: {

  }
}
</script>
<style scoped lang="scss">
  .menu{padding:0 $pageSpace;background: #fff}
</style>
